import { render, staticRenderFns } from "./StickyNote.vue?vue&type=template&id=74d8f06e&"
import script from "./StickyNote.vue?vue&type=script&lang=js&"
export * from "./StickyNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports